<template>
  <div class="container py-7">
    <div class="row">
      <div class="col-lg-12 mx-auto">
        <div class="row mb-3">
          <div class="col-md-3 d-none d-sm-block">
            <div class="text-md">{{ $t('Day') }}</div>
          </div>
          <div class="col-md-4 d-none d-sm-block">
            <div class="text-md">{{ $t('Work start and finish') }}</div>
          </div>
          <div class="col-md-4 d-none d-sm-block offset-1">
            <div class="text-md">{{ $t('Break time start and finish') }}</div>
          </div>
        </div>
        <div class="row mt-2" v-for="day in this.days" :key="day.id">
          <input type="hidden"
                 :name="'workingDays['+day.id+'][id]'"
                 :value="day.id">
          <div class="col-md-3">
            <div class="mt-3">
              <label class="ms-2 text-wrap text-md" :for="'working-day-'+day.id">
                <input class="form-check-input"
                       type="checkbox"
                       :name="'workingDays['+day.id+'][is_working]'"
                       :id="'working-day-'+day.id" :checked="day.is_working"
                       :value="day.is_working"
                       @click="toggleDay(event,day)">
                {{ day.day }}
              </label>
            </div>
          </div>
          <div class="col-md-2" v-show="day.display_times">
            <input type="text"
                   class="form-control"
                   id="timeStart"
                   :name="'workingDays['+day.id+'][time_start]'"
                   :value="day.time_start" onkeypress='validateNumAndSpecChars(event)'>
          </div>
          <div class="col-md-2" v-show="day.display_times">
            <input type="text"
                   class="form-control"
                   id="timeFinish"
                   :name="'workingDays['+day.id+'][time_finish]'"
                   :value="day.time_finish" onkeypress='validateNumAndSpecChars(event)'>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-2" v-show="day.display_times">
            <input type="text"
                   class="form-control"
                   id="timeBreakStart"
                   :name="'workingDays['+day.id+'][time_break_start]'"
                   :value="day.time_break_start" onkeypress='validateNumAndSpecChars(event)'>
          </div>
          <div class="col-md-2" v-show="day.display_times">
            <input type="text"
                   class="form-control"
                   id="timeBreakFinish"
                   :name="'workingDays['+day.id+'][time_break_finish]'"
                   :value="day.time_break_finish" onkeypress='validateNumAndSpecChars(event)'>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkingSchedule",
  props: {
    workingDays: Array,
  },
  data: function () {
    return {
      days: []
    }
  },
  methods: {
    toggleDay(event, day) {
      day.display_times = !day.display_times;
    },
    initialValues() {
      if (this.workingDays.length != 0) {
        this.days = this.workingDays;

        this.days.every(day => {
          day.display_times = day.is_working;
          return day;
        })
      }
    }
  },
  mounted() {
    console.log('loaded')
    this.initialValues();
  },
  created() {

  }
}
</script>

<style scoped>

</style>
